<template>
  <div class="view-tools">
    <h4 class="text-semibold mb-4">Ferramentas</h4>
    <div v-for="(scope, i) in toolList" :key="i" class="tools-row mb-6">
      <feature-card
        v-for="(tool, i) in scope.options"
        @click="$router.push({ name: tool.route })"
        fill
        :key="i"
        :icon="tool.icon"
        :title="tool.name"
        :color="scope.color"
        :subtitle="tool.description"
      />
    </div>
  </div>
</template>

<script>
import { TOOLS_LIST } from "@/constants/tools.js";

import FeatureCard from "@/components/FeatureCard.vue";

export default {
  components: { FeatureCard },
  computed: {
    toolList() {
      return TOOLS_LIST(this.$config.get("title")).map(tool => {
        tool.options = tool.options.filter(opt => this.permitted(opt));
        return tool;
      });
    }
  },
  methods: {
    permitted(tool) {
      return (
        !tool.permission || this.$permissions.hasPermission(tool.permission)
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.view-tools {
  .tools-row {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(354px, 1fr));
    gap: 28px;
  }
}
</style>
